module.exports = __webpack_public_path__ + "static/img/img-9.6b853620.png";